import { pushEcommerceEvent } from '@app/infrastructure/gtm/pushEcommerceEvent';
import { GtmEventName } from '@app/domain/model/gtm/GtmEventName';
import { EcommerceItem } from '@app/domain/model/gtm/EcommerceItem';
import { TravelPremiumRisk } from '@app/domain/model/eshop/travel/TravelPremiumRisk';
import { TravelOffer } from '@app/domain/model/eshop/travel/TravelOffer';
import { getRiskItemCategory } from '@app/infrastructure/gtm/travel/getRiskItemCategory';

export interface TravelProposalCalculatedData {
    offers: TravelOffer;
    selectedRisks: TravelPremiumRisk[];
}

export function trackProposalCalculated(data: TravelProposalCalculatedData): void {
    const totalPrice = data.offers.priceToPayNow ?? 0;
    const firstPolicy = data.offers.policies[0];

    const items: EcommerceItem[] = data.selectedRisks
        .filter(risk => (risk.premiumAfterDiscount ?? risk.premium ?? 0) > 0)
        .map(risk => ({
            item_name: risk.name,
            item_id: risk.code ?? '',
            price: risk.premiumAfterDiscount ?? risk.premium ?? 0,
            item_category: getRiskItemCategory(risk.code),
            quantity: 1,
        }));

    pushEcommerceEvent(GtmEventName.ProposalCalculated, {
        currency: 'EUR',
        value: totalPrice,
        offer_number: firstPolicy?.offerNumber,
        items,
    });
}
